import image1 from '@/assets/images/news/detail/20201012/1.jpg';
import image2 from '@/assets/images/news/detail/20201012/2.jpg';
import image3 from '@/assets/images/news/detail/20201012/3.jpg';
import image4 from '@/assets/images/news/detail/20201012/4.jpg';
import image5 from '@/assets/images/news/detail/20201012/5.jpg';
import image6 from '@/assets/images/news/detail/20201012/6.jpg';
import image7 from '@/assets/images/news/detail/20201012/7.jpg';
import image8 from '@/assets/images/news/detail/20201012/8.jpg';

export default {
  id: '20201012', //  模块 id
  title: '有故事的墙 | 总部文化墙全新亮相', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text: '金秋十月是收获的季节',
      isIndent: false,
    },
    {
      type: 0,
      text: '总部大楼内也悄然收获焕新',
      isIndent: false,
    },
    {
      type: 0,
      text: '只见一楼和夹层的几座墙面被赋予了叮咚文化的色彩',
      isIndent: false,
    },
    {
      type: 0,
      text: '让小伙伴们有了新平台去感知更多叮咚故事和叮咚文化力量',
      isIndent: false,
    },
    {
      type: 0,
      text: '我们的云参观，从企业介绍墙开始，',
      isIndent: false,
    },
    {
      type: 0,
      text: 'Let\'s go!',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 0,
      text: '首先映入眼帘的是企业介绍墙，',
      isIndent: false,
    },
    {
      type: 0,
      text: '在这里，',
      isIndent: false,
    },
    {
      type: 0,
      text: '我们观看公司宣传片，',
      isIndent: false,
    },
    {
      type: 0,
      text: '重温叮咚商业模式，',
      isIndent: false,
    },
    {
      type: 0,
      text: '勉励自己时刻坚守对用户的承诺，',
      isIndent: false,
    },
    {
      type: 0,
      text: '做好确定性；',
      isIndent: false,
    },
    {
      type: 0,
      text: '在这里，',
      isIndent: false,
    },
    {
      type: 0,
      text: '叮咚之星在广袤的地图上把城市点亮，',
      isIndent: false,
    },
    {
      type: 0,
      text: '未来一定还会有更多的小星星照耀四方。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: '在叮咚，',
      isIndent: false,
    },
    {
      type: 0,
      text: '我们共同种下一棵树。',
      isIndent: false,
    },
    {
      type: 0,
      text: '把价值观和种子论交融在一起，',
      isIndent: false,
    },
    {
      type: 0,
      text: '就成了这面价值观形象墙。',
      isIndent: false,
    },
    {
      type: 0,
      text: '虽然现在它还只是一棵小树，',
      isIndent: false,
    },
    {
      type: 0,
      text: '但初心指引我们前进的方向，',
      isIndent: false,
    },
    {
      type: 0,
      text: '辛勤浇灌，迎风生长，',
      isIndent: false,
    },
    {
      type: 0,
      text: '它终会长成一棵参天大树。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3],
    },
    {
      type: 0,
      text: '来到一个绝佳的拍照打卡点',
      isIndent: false,
    },
    {
      type: 0,
      text: '——使命墙。',
      isIndent: false,
    },
    {
      type: 0,
      text: '城市剪影，',
      isIndent: false,
    },
    {
      type: 0,
      text: '表达叮咚要将美好的食材送达千家万户；',
      isIndent: false,
    },
    {
      type: 0,
      text: '具有科技感的芯片，',
      isIndent: false,
    },
    {
      type: 0,
      text: '表达叮咚目标打造自己的核心竞争力，',
      isIndent: false,
    },
    {
      type: 0,
      text: '打造生态供应链。',
      isIndent: false,
    },
    {
      type: 0,
      text: '我们还可以通过按钮互动，',
      isIndent: false,
    },
    {
      type: 0,
      text: '感知叮咚“产地-分选中心-前置仓-用户”的运营模式，',
      isIndent: false,
    },
    {
      type: 0,
      text: '全真还原的插画，',
      isIndent: false,
    },
    {
      type: 0,
      text: '满满的小细节。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4],
    },
    {
      type: 0,
      text: '通往夹层的楼梯上，',
      isIndent: false,
    },
    {
      type: 0,
      text: '“挂”起了一幅“世界地图”',
      isIndent: false,
    },
    {
      type: 0,
      text: '这是从叮咚“愿景”中提炼出的概念。',
      isIndent: false,
    },
    {
      type: 0,
      text: '细心的小伙伴会发现，',
      isIndent: false,
    },
    {
      type: 0,
      text: '地图由一张张世界各地的食材食品产地源头的照片拼成：',
      isIndent: false,
    },
    {
      type: 0,
      text: '中国东北大米，',
      isIndent: false,
    },
    {
      type: 0,
      text: '美国蔓越莓，',
      isIndent: false,
    },
    {
      type: 0,
      text: '格陵兰岛北极虾...',
      isIndent: false,
    },
    {
      type: 0,
      text: '既呈现一个广阔而美好的产地农业丰收图景，',
      isIndent: false,
    },
    {
      type: 0,
      text: '也指引着叮咚人奋斗的方向。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image5],
    },
    {
      type: 0,
      text: '夹层的叮咚大事记墙承载满满的记忆，',
      isIndent: false,
    },
    {
      type: 0,
      text: '这里记录着叮咚从2017年一路走来的点点滴滴。',
      isIndent: false,
    },
    {
      type: 0,
      text: '与传统的大事记墙不同，',
      isIndent: false,
    },
    {
      type: 0,
      text: '这是具有叮咚特色的大事记墙。',
      isIndent: false,
    },
    {
      type: 0,
      text: '每一个创新、突破、坚守、变革的“小”时光，',
      isIndent: false,
    },
    {
      type: 0,
      text: '都对叮咚的发展有着重大意义，',
      isIndent: false,
    },
    {
      type: 0,
      text: '都有值得细说的故事。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text: '沿着夹层往前走，',
      isIndent: false,
    },
    {
      type: 0,
      text: '叮咚独创的卡通蔬果漫画，',
      isIndent: false,
    },
    {
      type: 0,
      text: '配上独具特色的文案，',
      isIndent: false,
    },
    {
      type: 0,
      text: '让人不得不喜欢。',
      isIndent: false,
    },
    {
      type: 0,
      text: '（据说这些蔬果还是有专利哒）',
      isIndent: false,
    },
    {
      type: 0,
      text: '这边也是拍照打卡的绝佳位置，',
      isIndent: false,
    },
    {
      type: 0,
      text: '你可以pick最喜欢的卡通蔬果漫画，',
      isIndent: false,
    },
    {
      type: 0,
      text: '也可以对照员工工卡背面，',
      isIndent: false,
    },
    {
      type: 0,
      text: '找到一模一样的图案哦~',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image7],
    },
    {
      type: 0,
      text: '走进夹层“有胜蒜”会议室，',
      isIndent: false,
    },
    {
      type: 0,
      text: '发现它同时被赋予了党建活动室的功能。',
      isIndent: false,
    },
    {
      type: 0,
      text: '“心有所信 方能行远”',
      isIndent: false,
    },
    {
      type: 0,
      text: '传达拼搏奋斗的理念，',
      isIndent: false,
    },
    {
      type: 0,
      text: '鼓舞叮咚人牢记心中使命；',
      isIndent: false,
    },
    {
      type: 0,
      text: '挂画卷轴则展示了党的光辉历程...',
      isIndent: false,
    },
    {
      type: 0,
      text: '党建室建成，',
      isIndent: false,
    },
    {
      type: 0,
      text: '将为叮咚的红色基因增添光彩~',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image8],
    },
    {
      type: 0,
      text: '最后来到“不姜就”阶梯教室，',
      isIndent: false,
    },
    {
      type: 0,
      text: '我们会被一篇郁郁葱葱的“叮咚森林”吸引目光，',
      isIndent: false,
    },
    {
      type: 0,
      text: '小萝卜俏皮地探出了头，',
      isIndent: false,
    },
    {
      type: 0,
      text: '小哥们骑行在坡道一路向上，',
      isIndent: false,
    },
    {
      type: 0,
      text: '寓意叮咚人唯有通过拼搏和努力，',
      isIndent: false,
    },
    {
      type: 0,
      text: '才能不断攀登，',
      isIndent: false,
    },
    {
      type: 0,
      text: '摘得胜利的旗帜。',
      isIndent: false,
    },
    {
      type: 0,
      text: '森林树宣传栏里新近呈现的是一篇篇战“疫”记录，',
      isIndent: false,
    },
    {
      type: 0,
      text: '定格了叮咚人抗击疫情的身影。',
      isIndent: false,
    },
    {
      type: 0,
      text: '感谢所有为叮咚总部文化墙提供故事线索的小伙伴~',
      isIndent: false,
    },
    {
      type: 0,
      text: '叮咚文化家园，有你，有我，',
      isIndent: false,
    },
    {
      type: 0,
      text: '期待与更多小伙伴共建~',
      isIndent: false,
    },
  ],
};
